import React from 'react';

import CompareControls from './CompareControls';
import { ComparisonResults } from './ComparisonResults';

export function Compare() {
  return (
    <div>
      <CompareControls />
      <ComparisonResults />
    </div>
  );
}
